import React from 'react';
import styled from 'styled-components';

const HeaderStyled = styled.header`
    background-color: ${props => props.theme.header.backgroundColor};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px 0 40px;
    height: 60px;

    @media screen and (max-width: 500px) {
        padding: 15px;
    }
`;

const Title = styled.div`
    font-size: 24px;
    color: ${props => props.theme.header.color};

    @media screen and (max-width: 500px) {
        font-size: 22px;
    }
`;

const Header = () => {
    return (
        <HeaderStyled>
            <Title>
                Защита на личните данни
            </Title>
        </HeaderStyled>
    )
};

export default Header;